import { Theatre } from '@ingka/modal';
import styled from '@emotion/styled';
import { theme } from '../../../../../shared/styles/core/theme';
import { tokens } from '../../../../../shared/styles/core/tokens';

export const StyledTheatre = styled(Theatre)`
   height: fit-content;
   max-height: calc(100% - ${tokens.space.xl});
   overflow: hidden;

   & > .theatre__content-wrapper {
      display: flex;
      flex-direction: column;
      height: auto;
      max-height: inherit;
      overflow: hidden;
   }
`;

export const TheatreHeaderDiv = styled.div`
   padding: ${tokens.space['3xl']} ${tokens.space['3xl']} ${tokens.space.xl};
`;

export const TheatreContentDiv = styled.div`
   padding: 0 ${tokens.space['3xl']} ${tokens.space['3xl']};
   display: flex;
   flex-direction: column;
   flex: 1 1 auto;
   overflow-y: auto;
   min-height: 0;
   gap: ${tokens.space.lg};
`;

export const FlexColumn = styled.div<{ $gap?: keyof typeof tokens.space }>`
   padding: ${tokens.space.md};
   display: flex;
   flex-direction: column;
   gap: ${({ $gap = 'md' }) => tokens.space[$gap]};
`;

export const FlexRow = styled.div<{ $gap?: keyof typeof tokens.space }>`
   display: flex;
   gap: ${({ $gap = 'lg' }) => tokens.space[$gap]};
   flex-wrap: wrap;
   align-items: center;
`;

export const CountBadge = styled.div`
   position: absolute;
   top: -0.5em;
   left: calc(50% + 1em);
   background: ${theme.colors.state.error};
   color: ${theme.colors.text.inverse};
   padding: ${tokens.space.sm} ${tokens.space.sm};
   min-width: 2em;
   height: 2em;
   display: flex;
   align-items: center;
   justify-content: center;
   border-radius: ${tokens.radius.pill};
   font-size: ${tokens.font.size.sm};
   z-index: ${tokens.zIndex.base};
`;

const previewCardBorderColor = {
   success: theme.colors.state.success,
   error: theme.colors.state.error,
   warning: theme.colors.state.warning,
} as const;

export const PreviewCard = styled.div<{ $variant?: keyof typeof previewCardBorderColor }>`
   border: ${tokens.border.thin}
      ${({ $variant }) => ($variant ? previewCardBorderColor[$variant] : theme.colors.border.default)};
   border-radius: ${tokens.radius.md};
   overflow: hidden;
`;

export const PreviewChip = styled.span<{ $changed: boolean; $isNew?: boolean }>`
   display: inline-block;
   padding: ${tokens.space.xs} ${tokens.space.sm};
   background-color: ${theme.colors.bg.tertiary};
   border-radius: ${tokens.radius.sm};
   font-size: ${tokens.font.size.sm};
   white-space: nowrap;
   font-weight: ${({ $changed }) => ($changed ? tokens.font.weight.bold : tokens.font.weight.normal)};
   ${({ $changed, $isNew }) =>
      $changed ? `border: ${tokens.border.thin} ${$isNew ? theme.colors.state.success : theme.colors.state.warning};` : ''}
`;
